import { useEffect, useState, useTransition } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as CloseIconRed } from "../../assests/icons/close_icon_red.svg";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { dialogActions } from "../../store/reducers/dialog";
import { useNavigate } from "react-router-dom";
import CircularLoader from "../CircularLoader";
import { InputLabel, Skeleton, TextField, Typography } from "@mui/material";
import { ConnectionsToken, homeToken } from "../../utils/constant";
import { useTranslation } from "react-i18next";
import { useGetRequests } from "../../utils/queries";
import { testimonialsApiUrl } from "../../utils/config";
import {
  InputDialogBoxWrap,
  InputLabelBoxBig,
  InputLabelBoxSmall
} from "./Dialog.styles";

const InputDialogBox = ({
  dialogTitle,
  leftBtnVal,
  rightBtnVal,
  leftbuttonHandler,
  ...props
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const [loader, setLoader] = useState(false);
  const [isSkeleton, setIsSkeleton] = useState(true);
  const [defaultMessage, setDefaultMessage] = useState("");
  const [isInputError, setIsInputError] = useState(false);
  const theme = useTheme();
  const dialogType = useSelector((state) => state.dialog.dialogType);
  const dialogData = useSelector((state) => state.dialog.dataObj);
  const profileData = useSelector((state) => state.profileDetails.data);
  const connectionId = useSelector((state) => state.dialog.requestId);
  const getTemplateMessage = useGetRequests();

  const handleClose = () => {
    setOpen(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    dispatch(dialogActions.setDataObj({}));
    dispatch(dialogActions.setRequestId(0));
  };

  useEffect(() => {
    if (dialogType === "asktestimonial") {
      getTemplateMessage.mutate(
        {
          url: `${testimonialsApiUrl}${connectionId}/request`,
        },
        {
          mutationKey: "getTestimonialTemplate",
          onSuccess: (success) => {
            if (
              success.status === 200 &&
              success.data.content.responseMessage.toLowerCase() === "success"
            ) {
              setDefaultMessage(success.data.content.recommendationBody);
              setIsSkeleton(false);
            }
          },
          onError: (error) => {
            console.log(" api call error data my connections is ", error);
            alert(t(homeToken.GenericError));
          },
        }
      );
    } else if (dialogType === "givetestimonial") {
      setTimeout(() => {
        setIsSkeleton(false);
      }, 1000);
    }
  }, []);

  const handleGiveorAsk = () => {
    if (defaultMessage.trim() !== "") {
      leftbuttonHandler(defaultMessage);
    } else {
      setIsInputError(true);
    }
  };

  return (
    <Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth={false}
      >
        <InputDialogBoxWrap>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              paddingBottom: "0.2rem",
              borderBottom: "1px solid #c8c8c8",
            }}
          >
            <DialogTitle
              id="responsive-dialog-title"
              sx={{
                margin: "auto",
                padding: "0",
                fontSize: "2.5rem",
                color: "#cf2030",
                "@media only screen and (max-width: 750px)": {
                  width: "90%",
                },
              }}
            >
              {dialogTitle}
            </DialogTitle>
            <CloseIconRed onClick={handleClose} />
          </Box>
          <Box sx={{ width: "100%" }}>
            <DialogContent>
            <InputLabelBoxSmall>
                  <InputLabel>
                    {dialogType === "givetestimonial"?t(ConnectionsToken.Testimonial):t(homeToken.Message)}
                    <Box sx={{ color: "#cf2030" }} component={"span"}>
                      {" "}
                      *
                    </Box>
                  </InputLabel>
                </InputLabelBoxSmall>
              <InputLabel
                sx={{
                  textAlign: "right",
                  p: 1,
                  color: "#cf2020",
                  visibility: isInputError ? "visible" : "hidden",
                }}
              >
                * {t(homeToken.RequiredFields)}
              </InputLabel>
              <Box sx={{ display: "flex", columnGap: "2rem" }}>
                <InputLabelBoxBig>
                  <InputLabel>
                    {dialogType === "givetestimonial"?t(ConnectionsToken.Testimonial):t(homeToken.Message)}
                    <Box sx={{ color: "#cf2030" }} component={"span"}>
                      {" "}
                      *
                    </Box>
                  </InputLabel>
                </InputLabelBoxBig>
                {isSkeleton ? (
                  <Box
                    sx={{
                      flex: "82%",
                      height: "13.7rem",
                      backgroundColor: "#F2F2F2",
                      borderRadius: "0.5rem",
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                      padding: "1rem 1rem",
                    }}
                    data-color-mode="light"
                  >
                   
                    <Skeleton animation="wave" variant="rectangular" sx={{width:"45%",height:"16%",backgroundColor:"#c8c8c8", borderRadius: "0.5rem",}}/>
              <Skeleton animation="wave" variant="rectangular" sx={{width:"70%",height:"16%",backgroundColor:"#c8c8c8", borderRadius: "0.5rem",}}/>
              <Skeleton animation="wave" variant="rectangular" sx={{width:"85%",height:"16%",backgroundColor:"#c8c8c8", borderRadius: "0.5rem",}}/>
              <Skeleton animation="wave" variant="rectangular" sx={{width:"98%",height:"16%",backgroundColor:"#c8c8c8", borderRadius: "0.5rem",}}/>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      flex: "82%",
                      height: "13.7rem",
                      backgroundColor: "#F2F2F2",
                      border: isInputError && "0.2rem solid #cf2030",
                      borderRadius: "0.5rem",
                      padding: "0rem 1rem 0rem 1rem",
                    }}
                    data-color-mode="light"
                  >
                    <TextField
                      multiline
                      placeholder={t(homeToken.EnterMessage)}
                      fullWidth
                      maxRows={5}
                      minRows={5}
                      variant="standard"
                      value={defaultMessage}
                      onChange={(e) => {
                        setDefaultMessage(e.target.value);
                        setIsInputError(false);
                      }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                      sx={{
                        fontSize: "1.4rem",
                        ".MuiInputBase-input": { color: '#64666A',scrollbarWidth: "auto" },
                        ".MuiInputBase-input::-webkit-scrollbar": { width:"0.7rem", right:"0.5rem"}
                      }}
                      className="message-text-field"
                    />
                  </Box>
                )}
              </Box>
            </DialogContent>
          </Box>
          <DialogActions sx={{ padding: "0", gap: ".8rem" }}>
            <Box sx={{ cursor: isSkeleton && "not-allowed" }}>
              <Button
                onClick={handleGiveorAsk}
                sx={{
                  pointerEvents: isSkeleton ? "none" : "auto",
                  minWidth: "10rem",
                  padding: "0 1rem",
                  border: "2px solid #cf2030",
                  background: "#cf2030",
                  color: "#f2f2f2",
                  "&:hover": { background: "#cf2030" }
                }}
              >
                {t(homeToken.Submit)}
              </Button>
            </Box>
            <Button
              onClick={handleClose}
              sx={{
                minWidth: "10rem",
                padding: "0 1rem",
                border: "2px solid #cf2030",
                color: "#cf2030",
                "&:hover": { background: "#ffffff" },
              }}
            >
              {t(homeToken.Cancel)}
            </Button>
          </DialogActions>
        </InputDialogBoxWrap>
      </Dialog>
      {loader && <CircularLoader />}
    </Box>
  );
};

export default InputDialogBox;
